import axios from 'axios'
import { defineNuxtPlugin } from '#imports'
import { GotenbergService } from '~/lib/services/export/gotenberg'
import { GotenbergServiceKey } from '~/lib/symbols'

declare module '~/types/vue-shim' {
  interface AppGlobalProperties {
    $gotenberg: GotenbergService
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  const gotenberg = new GotenbergService(axios)
  nuxtApp.provide('gotenberg', gotenberg)
  nuxtApp.vueApp.provide(GotenbergServiceKey, gotenberg)
})
